import HttpData from "@/http/data/http-data";

export type AccessControlDoorAssignments = Record<string, boolean>;

export interface IAccessControlCardData {
    card_number: number;
    start_date: string;
    end_date: string;
    doors: AccessControlDoorAssignments;
    pin: number;
    unit_id: string | null;
}

export default class AccessControlCardData extends HttpData {
    public card_number: number;
    public start_date: string;
    public end_date: string;
    public doors: AccessControlDoorAssignments;
    public pin: number;
    public unit_id: string | null;

    constructor(data: IAccessControlCardData) {
        super();

        this.card_number = data.card_number;
        this.start_date = data.start_date;
        this.end_date = data.end_date;
        this.doors = data.doors;
        this.pin = data.pin;
        this.unit_id = data.unit_id;
    }
}
